// generated by srcset-codegen
import src from "./magnifying-glass.svg";

const width = 23;
const height = 23;
export default { src, width, height };
